export const notificationDeliveryMethods = [
  'discord_message',
  'email',
  'custom_webhook',
] as const

type NotificationTemplateMethod = typeof notificationDeliveryMethods[number]
export default NotificationTemplateMethod
